import { createAction, props } from '@ngrx/store';
import { IEmployeeBusinessDetailsRequest } from '../models/bi-update.model';

export const loadBiUpdateBusinessDetails = createAction(
  '[BiUpdateBusinessDetails] Load BiUpdateBusinessDetails',
  props<{ model: IEmployeeBusinessDetailsRequest; businessId: string; employeeId: string }>()
);

export const loadBiUpdateBusinessDetailsSuccess = createAction(
  '[BiUpdateBusinessDetails] Load BiUpdateBusinessDetails Success',
  props<{ response: string }>()
);

export const loadBiUpdateBusinessDetailsFailure = createAction(
  '[BiUpdateBusinessDetails] Load BiUpdateBusinessDetails Failure',
  props<{ error: Error | any }>()
);
